export default __webpack_public_path__ + "static/media/pinned.9dba0a70.png";